/**
 * Edit history — undo / redo / revert the masking.
 *
 * Extracted from `MaskEditor.tsx` (WS-J J-12). The buttons and their `data-testid`s are unchanged;
 * the history itself is per-editor since MN-5 (`useEditorHistoryBridge`, J-5).
 */
import { Icon } from "../../ui/Icon.js";

export interface HistoryCardProps {
  locked?: boolean;
  canUndo: boolean;
  canRedo: boolean;
  canRevert: boolean;
  undoGeo: () => void;
  redoGeo: () => void;
  revertGeo: () => void;
}

export function HistoryCard(p: HistoryCardProps) {
  const {
    locked, canUndo, canRedo, canRevert, undoGeo,
    redoGeo, revertGeo,
  } = p;
  return (
    <>
      {/* Edit history — undo / redo / revert the masking so the user can rework it. */}
      <div className="mask-editor__history" data-testid="mask-history">
        <button
          type="button"
          className="btn btn--sm"
          onClick={undoGeo}
          disabled={locked || !canUndo}
          title="Undo the last masking change"
          data-testid="mask-undo"
        >
          <Icon name="undo" size={16} /> Undo
        </button>
        <button
          type="button"
          className="btn btn--sm"
          onClick={redoGeo}
          disabled={locked || !canRedo}
          title="Redo"
          data-testid="mask-redo"
        >
          <Icon name="redo" size={16} /> Redo
        </button>
        <button
          type="button"
          className="btn btn--sm btn--ghost"
          onClick={revertGeo}
          disabled={locked || !canRevert}
          title="Revert the masking to how it opened"
          data-testid="mask-revert"
        >
          Revert to original
        </button>
      </div>
    </>
  );
}
